<template>
	<page>
		<module>
			<view-list
				ref="view"
				work-type="45"
				:view-config="saasInfo.viewmanage"
				selector
			>
				<template #search>
					<!--退货方向（我发起的退货/退货给我的）不做硬编码页签，由视图配置的过滤字段（direction）生成视图页签-->
					<m-search ref="search">
						<m-search-item label="退货单号">
							<c-input name="return_code" placeholder="请输入退货单号"></c-input>
						</m-search-item>
						<m-search-item label="退货状态">
							<c-select name="return_state" :options="PROFIT_RETURN_STATE" placeholder="全部"></c-select>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_profit_return_create')" color="main" prepend-icon="tf-add" @click="createReturn">创建分润退货</c-button>
					<c-button v-if="auth('b_profit_transfer_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
				</template>

				<template #return_state="{data}">
					<c-state dict="PROFIT_RETURN_STATE" tag :value="data.return_state"></c-state>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="200"
					button-limit="6"
				>
					<template #default="{data}">
						<!--方向以行数据 direction 判断（后端按当前商户视角计算），不再依赖页面页签-->
						<c-table-button icon="tf-detail" @click="viewDetail(data)">查看</c-table-button>
						<!-- 发起侧 -->
						<c-table-button v-if="data.direction == 1 && auth('b_profit_return_edit') && data.return_state == 1 && userInfo.id == data.create_user_id" icon="tf-edit" @click="editReturn(data)">编辑</c-table-button>
						<c-table-button v-if="data.direction == 1 && auth('b_profit_return_delete') && data.return_state == 1 && userInfo.id == data.create_user_id" icon="tf-trash" color="red" @click="deleteReturn(data)">删除</c-table-button>
						<!-- 接收侧 -->
						<c-table-button v-if="data.direction == 2 && auth('b_profit_return_receive') && data.return_state == 1" icon="tf-stock" color="main" @click="receiveReturn(data)">退货接收</c-table-button>
					</template>
				</c-table-column>
			</view-list>

			<!--创建/编辑分润退货弹窗-->
			<profit-return-edit ref="edit" @resolve="$refs.view.update()"></profit-return-edit>
			<!--退货详情抽屉-->
			<profit-return-detail ref="detail" @resolve="$refs.view.update()"></profit-return-detail>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import {asyncMapState} from '@/store'
	import profitReturnEdit from "@/pages/storage/profit_return_edit.vue";
	import profitReturnDetail from "@/pages/storage/profit_return_detail.vue";

	export default {
		name: 'm_profit_transfer_return',

		components: {profitReturnEdit, profitReturnDetail},

		computed: {
			...mapState(['saasInfo', 'userInfo']),

			...asyncMapState(['PROFIT_RETURN_STATE'])
		},

		methods: {
			/********创建分润退货************/
			createReturn() {
				this.$refs.edit.open();
			},

			/********编辑分润退货************/
			editReturn(data) {
				this.$refs.edit.open(data);
			},

			/********查看退货详情（方向由详情接口按当前商户视角返回）************/
			viewDetail(data) {
				this.$refs.detail.open(data.id);
			},

			/********退货接收************/
			receiveReturn(data) {
				this.$refs.detail.open(data.id, true);
			},

			/********删除分润退货************/
			deleteReturn(data) {
				this.$confirm({
					message: '确认删除退货单【' + data.return_code + '】？删除后商品退货状态将回退，不可恢复！',
					buttonName: '确定删除',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/profitTransferReturn/delete',
							data: {id: data.id},
							loading: true,
							success: (res, msg) => {
								this.$message({message: msg || '删除成功', type: 'success'});
								this.$refs.view.update();
							}
						});
					}
				});
			}
		}
	}
</script>
